/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var OutsideClick_1 = require("./util/OutsideClick");
var Input_1 = require("./Input");
var Icon_1 = require("./Icon");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./SuggestionField.css'); }
var CSS_BASE_CLASS = "m-suggestionField";
var KEYCODE = {
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    LEFT: 37,
    ENTER: 13,
    TAB: 9
};
var propTypes = tslib_1.__assign({ showPlaceholder: PropTypes.bool, maxResults: PropTypes.number, mapResult: PropTypes.func, immediateSearch: PropTypes.bool, showIcon: PropTypes.bool, onSearch: PropTypes.func.isRequired, onSelect: PropTypes.func.isRequired }, Input_1.Input.propTypes);
delete propTypes.value;
var SuggestionField = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionField, _super);
    function SuggestionField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            query: _this.props.defaultValue || "",
            suggestions: [],
            focusedIndex: 0,
            noResults: false,
            showSuggestions: false
        };
        _this.handleKeyUp = _this.handleKeyUp.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.requestClose = _this.requestClose.bind(_this);
        _this.handleSelect = _this.handleSelect.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        return _this;
    }
    SuggestionField.prototype.componentDidMount = function () {
        if (this.props.immediateSearch) {
            this.search(this.state.query, false);
        }
    };
    SuggestionField.prototype.componentWillUnmount = function () {
        if (this.blurTimeout) {
            clearTimeout(this.blurTimeout);
        }
    };
    SuggestionField.prototype.handleKeyUp = function (e) {
        switch (e.keyCode) {
            case KEYCODE.ENTER:
            case KEYCODE.RIGHT:
            case KEYCODE.LEFT:
            case KEYCODE.TAB:
                return;
            default:
                this.setState({ showSuggestions: true });
                break;
        }
    };
    /* tslint:disable:cyclomatic-complexity */
    SuggestionField.prototype.handleKeyDown = function (e, query) {
        // eslint-disable-line max-statements,complexity
        var newState = {};
        if (e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) {
            return;
        }
        if (!query) {
            newState.noResults = false;
        }
        if (this.state.showSuggestions) {
            var currentIndex = this.state.focusedIndex;
            var suggestions = this.state.suggestions;
            var focusedSuggestion = suggestions[currentIndex];
            var limit = this.props.maxResults
                ? Math.min(this.props.maxResults, suggestions.length)
                : suggestions.length;
            var keyCode = e.keyCode;
            if (focusedSuggestion &&
                (keyCode === KEYCODE.ENTER ||
                    keyCode === KEYCODE.RIGHT ||
                    keyCode === KEYCODE.TAB)) {
                e.preventDefault();
                this.handleSelect(focusedSuggestion);
                newState.showSuggestions = false;
                newState.focusedIndex = 0;
            }
            else if (keyCode === KEYCODE.UP) {
                e.preventDefault();
                newState.focusedIndex =
                    currentIndex <= 0 ? limit - 1 : currentIndex - 1;
            }
            else if (keyCode === KEYCODE.DOWN) {
                e.preventDefault();
                newState.focusedIndex =
                    currentIndex >= limit - 1 ? 0 : currentIndex + 1;
            }
            else {
                newState.focusedIndex = 0;
            }
            if (this.listElement) {
                this.listElement.scrollTop =
                    newState.focusedIndex * 41 - this.listElement.clientHeight / 2 + 20;
            }
        }
        this.setState(newState);
    };
    SuggestionField.prototype.requestClose = function () {
        var _this = this;
        this.blurTimeout = window.setTimeout(function () {
            _this.setState({
                showSuggestions: false,
                noResults: false
            });
        }, 10);
    };
    SuggestionField.prototype.handleSelect = function (selection, e) {
        if (e) {
            e.preventDefault();
        }
        var _a = this.props, mapResult = _a.mapResult, onSelect = _a.onSelect;
        this.setState({
            showSuggestions: false,
            suggestions: [],
            query: mapResult(selection, this.state.query).value
        });
        onSelect && onSelect(selection);
    };
    SuggestionField.prototype.handleFocus = function () {
        if (this.props.immediateSearch) {
            this.setState({ showSuggestions: true });
            this.search(this.state.query, false);
        }
    };
    SuggestionField.prototype.handleChange = function (event, query) {
        this.search(query, true);
    };
    SuggestionField.prototype.search = function (query, queryCheck) {
        var _this = this;
        if (queryCheck === void 0) { queryCheck = false; }
        var onSearch = this.props.onSearch;
        this.setState({
            query: query
        });
        onSearch &&
            onSearch(query).then(function (results) {
                if (!queryCheck || _this.state.query === query) {
                    _this.setState({
                        suggestions: results,
                        noResults: !results.length
                    });
                }
            });
    };
    SuggestionField.prototype.renderSuggestions = function () {
        var _this = this;
        var _a = this.props, mapResult = _a.mapResult, maxResults = _a.maxResults;
        var _b = this.state, suggestions = _b.suggestions, focusedIndex = _b.focusedIndex, query = _b.query;
        return (React.createElement("ul", { className: CSS_BASE_CLASS + "-list", ref: function (el) { return (_this.listElement = el); } }, suggestions
            .slice(0, maxResults || suggestions.length)
            .map(function (suggestion, index) {
            var boundHandleSelect = _this.handleSelect.bind(_this, suggestion);
            var itemClassNames = classnames(CSS_BASE_CLASS + "-item", index === focusedIndex
                ? CSS_BASE_CLASS + "-itemFocused"
                : undefined);
            var mappedSuggestion = mapResult(suggestion, query);
            return (React.createElement("li", { key: mappedSuggestion.name, className: itemClassNames },
                React.createElement("a", { href: "#", tabIndex: -1, onClick: boundHandleSelect }, mappedSuggestion.node || mappedSuggestion.value)));
        })));
    };
    SuggestionField.prototype.renderPlaceholder = function () {
        var focusedSuggestion = this.props.mapResult(this.state.suggestions[this.state.focusedIndex], this.state.query);
        return (React.createElement("div", { className: CSS_BASE_CLASS + "-placeholder" }, focusedSuggestion.node || focusedSuggestion.value));
    };
    SuggestionField.prototype.render = function () {
        var _a = this.props, onSelect = _a.onSelect, maxResults = _a.maxResults, defaultValue = _a.defaultValue, showIcon = _a.showIcon, showPlaceholder = _a.showPlaceholder, children = _a.children, textFieldProps = tslib_1.__rest(_a, ["onSelect", "maxResults", "defaultValue", "showIcon", "showPlaceholder", "children"]);
        var _b = this.state, suggestions = _b.suggestions, showSuggestions = _b.showSuggestions, noResults = _b.noResults, query = _b.query, focusedIndex = _b.focusedIndex;
        var focusedSuggestion = suggestions[focusedIndex];
        var hasSuggestions = !!suggestions.length;
        var classNames = classnames(CSS_BASE_CLASS, showPlaceholder && showSuggestions && focusedSuggestion
            ? CSS_BASE_CLASS + "-showPlaceholder"
            : null, showSuggestions && focusedSuggestion
            ? CSS_BASE_CLASS + "-focusedSuggestion"
            : null, showIcon ? CSS_BASE_CLASS + "-hasIcon" : null);
        return (React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: this.requestClose, className: classNames },
            React.createElement(Input_1.Input, tslib_1.__assign({ onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, onFocus: this.handleFocus, onChange: this.handleChange, value: query, 
                // since some browsers ignore "off", we silence autocomplete by
                // declaring a "new-password" input
                autoComplete: "new-password" }, textFieldProps),
                showPlaceholder &&
                    showSuggestions &&
                    focusedSuggestion &&
                    this.renderPlaceholder(),
                showSuggestions && hasSuggestions && this.renderSuggestions(),
                showSuggestions && noResults && !!query ? (React.createElement("div", { className: CSS_BASE_CLASS + "-noResults" }, children)) : null,
                showIcon && (React.createElement(Icon_1.Icon, { type: "select", className: CSS_BASE_CLASS + "-chevron" })))));
    };
    SuggestionField.propTypes = propTypes;
    SuggestionField.defaultProps = {
        type: "search",
        showPlaceholder: false,
        immediateSearch: false,
        showIcon: false,
        maxResults: 5,
        mapResult: function (result) { return result; }
    };
    SuggestionField.safeRegexp = function (val) {
        return val.replace(/([\[\]\\\)\(\?\+\*\.\$\^])/g, function (match) { return "\\" + match; });
    };
    SuggestionField.wrapSelection = function (val, query, tokenDelimiter) {
        if (tokenDelimiter === void 0) { tokenDelimiter = "__TOKEN_DELIIMTER__"; }
        if (!query || !val) {
            return val;
        }
        var safeQuery = SuggestionField.safeRegexp(query);
        var queryRegExp = new RegExp(safeQuery, "i");
        return val
            .replace(queryRegExp, function (match) { return "" + tokenDelimiter + match + tokenDelimiter; })
            .split(tokenDelimiter)
            .filter(function (part) { return !!part; })
            .map(function (part, i) {
            if (part.search(queryRegExp) !== 0) {
                return React.createElement("span", { key: i }, part);
            }
            return (React.createElement("span", { key: i + "-k", className: CSS_BASE_CLASS + "-itemSelection" }, part));
        });
    };
    return SuggestionField;
}(React.Component));
exports.SuggestionField = SuggestionField;